module.exports = __webpack_public_path__ + "media/images/flags/1x1/cxr-e2182aabb68b3b1e3b07d6a69dac148e.svg";